import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useMoralis } from "react-moralis";
import {
  Card,
  Image,
  Tooltip,
  Modal,
  Input,
  Alert,
  Spin,
  Button,
  Badge,
  Select,
} from "antd";
import { useNFTBalance } from "hooks/useNFTBalance";
import { FileSearchOutlined, ShoppingCartOutlined } from "@ant-design/icons";
import { useMoralisDapp } from "providers/MoralisDappProvider/MoralisDappProvider";
import { getExplorer } from "helpers/networks";
import { useWeb3ExecuteFunction, useMoralisQuery } from "react-moralis";
import { makeTokenizer } from "@tokenizer/http";

import Slider from "react-slick";
const { Meta } = Card;
const { Option } = Select;

function NFTBalance({ setNFT, setViewType }) {
  const fallbackImg =
    "data:image/png;base64,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";
  const history = useHistory();
  const { NFTBalance, fetchSuccess } = useNFTBalance();
  const { walletAddress, chainId, marketAddress, contractABI } =
    useMoralisDapp();
  // const [approved, setApproved] = useState(false);
  const contractProcessor = useWeb3ExecuteFunction();
  const contractABIJson = JSON.parse(contractABI);
  const queryMarketItems = useMoralisQuery("EvNewOffer");
  const [sortType, setSortType] = useState(0);
  const sortCategory = ["low -> high", "high -> low"];
  const [sortedNFTBalance, setSortedNFTBalance] = useState([]);

  const fetchMarketItems = JSON.parse(
    JSON.stringify(queryMarketItems.data, [
      "objectId",
      "createdAt",
      "user",
      "nft",
      "tokenId",
      "price",
      "side",
      "uid",
      "confirmed",
    ])
  );

  useEffect(() => {
    sortNFTTokenBalance(NFTBalance, sortType);
  }, [NFTBalance, sortType]);

  const sortNFTTokenBalance = async (_NFTTokenBalance, _sortType) => {
    let orderedIds = [];
    let unOrderedIds = [];
    for (let i = 0; i < _NFTTokenBalance.length; i++) {
      let _NFTTokenId = _NFTTokenBalance[i];
      if (_NFTTokenId.image) {
        _NFTTokenId.image = _NFTTokenId.image.replace(
          "ipfs://",
          "https://ipfs.io/ipfs/"
        );
      }
      if (_NFTTokenId?.image) {
        const httpTokenizer = await makeTokenizer(_NFTTokenId.image);
        if (
          [
            "m4v",
            "avi",
            "mpg",
            "mp4",
            "video/mp4",
            "video/mpg",
            "video/avi",
            "video/m4v",
          ].includes(httpTokenizer.fileInfo.mimeType)
        ) {
          _NFTTokenId.file = httpTokenizer.fileInfo.mimeType;
          _NFTTokenId.fileType = "video";
        } else if (
          ["mp3", "wav", "ogg", "audio/mp3", "audio/wav", "audio/ogg"].includes(
            httpTokenizer.fileInfo.mimeType
          )
        ) {
          _NFTTokenId.file = httpTokenizer.fileInfo.mimeType;
          _NFTTokenId.fileType = "audio";
        } else {
          _NFTTokenId.file = httpTokenizer.fileInfo.mimeType;
          _NFTTokenId.fileType = "image";
        }
      }

      if (getMarketItem(_NFTTokenId)) {
        orderedIds = [...orderedIds, _NFTTokenId];
      } else {
        unOrderedIds = [...unOrderedIds, _NFTTokenId];
      }
    }
    if (_sortType === 0) {
      orderedIds.sort(
        (a, b) => getMarketItem(a).price - getMarketItem(b).price
      );
    } else {
      orderedIds.sort(
        (a, b) => getMarketItem(b).price - getMarketItem(a).price
      );
    }
    let _sortedNFTBalance = [...orderedIds, ...unOrderedIds];
    setSortedNFTBalance(_sortedNFTBalance);
  };

  const getMarketItem = (nft) => {
    const result = fetchMarketItems?.find(
      (e) =>
        e.nft.toLowerCase() === nft?.token_address.toLowerCase() &&
        e.tokenId === nft?.token_id &&
        e.side === 1 &&
        e.confirmed === true
    );
    return result;
  };

  async function isApprovedForAll(nft) {
    const ops = {
      contractAddress: nft.token_address,
      functionName: "isApprovedForAll",
      abi: [
        {
          inputs: [
            { internalType: "address", name: "owner", type: "address" },
            { internalType: "address", name: "operator", type: "address" },
          ],
          name: "isApprovedForAll",
          outputs: [{ internalType: "bool", name: "", type: "bool" }],
          stateMutability: "view",
          type: "function",
        },
      ],
      params: {
        owner: walletAddress,
        operator: marketAddress,
      },
    };
    let flag = false;
    await contractProcessor.fetch({
      params: ops,
      onSuccess: (result) => {
        // setApproved(result);
        flag = result;
      },
      onError: (error) => {
        // setApproved(false);
        flag = false;
      },
    });
    return flag;
  }

  const handleSellClick = async (nft) => {
    setNFT(nft);
    let flag = await isApprovedForAll(nft);
    if (flag) setViewType(1);
    else setViewType(0);
    history.push("/SingleItem/".concat(nft.token_address, "/", nft.token_id));
  };

  const handleSortTypeChange = (value) => {
    if (value === "low -> high") {
      setSortType(0);
    } else {
      setSortType(1);
    }
  };

  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      <div>
        {contractABIJson.noContractDeployed && (
          <>
            <Alert
              message="No Smart Contract Details Provided. Please deploy smart contract and provide address + ABI in the MoralisDappProvider.js file"
              type="error"
            />
            <div style={{ marginBottom: "10px" }}></div>
          </>
        )}
        {!fetchSuccess && (
          <>
            <Alert
              message="Unable to fetch all NFT metadata... We are searching for a solution, please try again later!"
              type="warning"
            />
            <div style={{ marginBottom: "10px" }}></div>
          </>
        )}
        <section className="py-5 mt-5">
          <div className="container mt-5">
            <div style={{ marginBottom: "16px" }}>
              <Select
                defaultValue={sortCategory[0]}
                style={{ width: 120 }}
                onChange={handleSortTypeChange}
                className="sliderFilter no-left-margin-filter"
              >
                {sortCategory.map((sortCategoryItem) => (
                  <Option key={sortCategoryItem}>{sortCategoryItem}</Option>
                ))}
              </Select>
            </div>
            <Slider {...settings} className="container py-5">
              {sortedNFTBalance &&
                sortedNFTBalance.map((nft, index) => (
                  <Card
                    hoverable
                    cover={
                      <div className="swiper-slide p-2">
                        <div className="card rounded shadow-sm card-hover-image">
                          <div className="card-body p-3 position-relative">
                            <div
                              className="position-relative mb-4 shadow"
                              style={{ paddingTop: "0px" }}
                            >
                              <div className="badge_col_safemars min_height_price">
                                {getMarketItem(nft) && (
                                  <Badge.Ribbon
                                    text={
                                      getMarketItem(nft).price / ("1e" + 9) +
                                      " (SAFEMARS)"
                                    }
                                    color="green"
                                  ></Badge.Ribbon>
                                )}
                              </div>
                              <div className="card-img-holder rounded overflow-hidden">
                                {(() => {
                                  if (nft.fileType === "video") {
                                    return (
                                      <video
                                        width="100%"
                                        height="100%"
                                        controls
                                      >
                                        <source
                                          src={nft.image}
                                          type={nft.file}
                                        />
                                      </video>
                                    );
                                  } else if (nft.fileType === "image") {
                                    return (
                                      <Image
                                        preview={false}
                                        src={nft?.image || "error"}
                                        fallback={fallbackImg}
                                        alt=""
                                      />
                                    );
                                  } else if (nft.fileType === "audio") {
                                    return (
                                      <audio controls>
                                        <source
                                          src={nft.image}
                                          type={nft.file}
                                        />
                                      </audio>
                                    );
                                  }
                                })()}
                              </div>
                            </div>
                            <p className="fw-bold mb-3">
                              <Meta
                                title={nft.name}
                                description={nft.contract_type}
                              />
                            </p>
                            <div className="my-3 pt-1 bg-body rounded-pill"></div>
                            <div className="row nft_cards">
                              <div
                                className="col-md-12"
                                style={{ minHeight: "30px" }}
                              >
                                <Tooltip title="List NFT for sale">
                                  <a
                                    href={() => false}
                                    className="btn btn-gradient-primary buy_now_button col-12"
                                    onClick={() => handleSellClick(nft)}
                                  >
                                    List
                                  </a>
                                </Tooltip>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                    key={index}
                    onClick={() => handleSellClick(nft)}
                  ></Card>
                ))}
            </Slider>
          </div>
        </section>
      </div>
    </>
  );
}

export default NFTBalance;
